module.exports = __webpack_public_path__ + "img/quizzort_btn.57b22cec.png";